<div class="card px-3 py-3 mb-3">
    <a [routerLink]="['/parking/' + parking.$key]">
        <div class="font-weight-bold">
            {{ parking.title }}
        </div>
        <div>
            {{ parking.parkingLocation?.suburb }} ·
            {{ parking.parkingLocation?.city }}
        </div>
    </a>
</div>
